import { Box, Flex } from '@mantine/core';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import MarkdownEditor from 'src/common/components/markdown-editor/MarkdownEditor';
import { GroupedSuggestions } from 'src/common/components/markdown-editor/plugins/SuggestionTrackerPlugin';
import { useContentMeta } from 'src/UI/app-container';
import { DocumentPanel } from './components';

const mockContent = `# Suitability Report

## Executive Summary

This report outlines the investment recommendations for the client based on their financial goals, risk tolerance, and current circumstances.

## Client Objectives

- Retirement planning with target age of 65
- Education funding for children
- Wealth preservation and growth

## Risk Assessment

The client has been assessed as having a **moderate** risk profile based on:

1. Investment experience
2. Time horizon
3. Financial capacity for loss

## Recommendations

| Product | Amount | Rationale |
| ------- | ------ | --------- |
| ISA | £20,000 | Tax-efficient growth |
| Pension | £40,000 | Retirement provision |
| GIA | £15,000 | Flexibility |

## Next Steps

<suggestion>Review recommended products with client and obtain agreement to proceed.</suggestion>
`;

export default function SuitabilityReportEditPage() {
  const { clientId, id } = useParams<{ clientId: string; id: string }>();
  const [suggestions, setSuggestions] = useState<GroupedSuggestions>({ default: {}, note: {} });
  const [showMarkers, setShowMarkers] = useState(true);

  useContentMeta({
    pageType: 'suitability-report-edit',
    entityId: id,
  });

  return (
    <Flex direction="column" h="100%">
      <DocumentPanel
        backHref={`/client/${clientId}/non-financial-data/suitability-reports`}
        title="Annual Review 2024"
        version="V3"
        versionDate="Nov 20, 5:28 PM"
        versionVariant="primary"
        suggestions={suggestions}
        showMarkers={showMarkers}
        onShowMarkersChange={setShowMarkers}
      />

      <Box mt="md" style={{ flex: 1, overflow: 'auto' }}>
        <MarkdownEditor
          defaultValue={mockContent}
          bare
          onSuggestionsChange={setSuggestions}
          showMarkers={showMarkers}
        />
      </Box>
    </Flex>
  );
}
